import { Field, ID, InputType, Int, ObjectType } from 'type-graphql'

import { ObjectRef, ScalarObject } from '@things-factory/shell'

import { DataOoc, DataOocStatus } from './data-ooc.js'

@InputType()
export class NewDataOoc {
  @Field({ description: 'Name of the OOC event for identification.' })
  name: string

  @Field({ nullable: true, description: 'Description of the OOC event.' })
  description?: string

  @Field(type => ObjectRef, { nullable: true, description: 'Reference to the dataset this OOC event belongs to.' })
  dataSet?: ObjectRef

  @Field({ nullable: true, description: 'Version of the dataset when this OOC event was created.' })
  dataSetVersion?: number

  @Field(type => ObjectRef, {
    nullable: true,
    description: 'Reference to the data sample that triggered this OOC event.'
  })
  dataSample?: ObjectRef

  @Field(type => DataOocStatus, {
    nullable: true,
    description: 'Initial status of the OOC event in the corrective action workflow.'
  })
  state?: DataOocStatus

  @Field(type => ScalarObject, { nullable: true, description: 'The data values that triggered the OOC event.' })
  data?: any

  @Field({ nullable: true, description: 'Raw data string that triggered the OOC event.' })
  rawData?: string

  @Field({ nullable: true, description: 'Source of the OOC event (e.g., sensor ID, manual entry, external system).' })
  source?: string

  @Field({ nullable: true, description: 'Indicates if this event is out of control (OOC).' })
  ooc?: boolean

  @Field({ nullable: true, description: 'Indicates if this event is out of specification (OOS).' })
  oos?: boolean

  @Field({ nullable: true, description: 'Work date when the OOC event occurred.' })
  workDate?: string

  @Field({ nullable: true, description: 'Work shift when the OOC event occurred.' })
  workShift?: string

  @Field({ nullable: true, description: 'Timestamp when the OOC event was detected.' })
  collectedAt?: Date
}

@InputType()
export class DataOocPatch {
  @Field(type => ID, { nullable: true, description: 'Unique identifier for the OOC record.' })
  id?: string

  @Field(type => DataOocStatus, {
    nullable: true,
    description: 'Current status of the OOC event in the corrective action workflow.'
  })
  state?: DataOocStatus

  @Field({ nullable: true, description: 'Description of the corrective action taken to resolve the OOC issue.' })
  correctiveAction?: string
}

@ObjectType({ description: 'Represents a paginated list of OOC events.' })
export class DataOocList {
  @Field(type => [DataOoc], { description: 'List of OOC events.' })
  items: DataOoc[]

  @Field(type => Int, { description: 'Total number of OOC events in the list.' })
  total: number
}
